<template>
  <v-list-tile>
    <v-list-tile-action>
      <PaymentIcon name="pix" size="24" />
    </v-list-tile-action>

    <v-list-tile-content>
      <v-list-tile-title class="font-weight-medium">
        Pagamento PIX
        <v-icon small>help_outline</v-icon>
      </v-list-tile-title>
      <v-list-tile-sub-title v-if="partner === 'establishment'">
        Faça pagamentos via PIX (chave, copia e cola ou dados bancários) direto da sua conta digital
        {{ account.fantasy_name }}.
      </v-list-tile-sub-title>
      <v-list-tile-sub-title v-else>
        Faça pagamentos via PIX (chave, copia e cola ou dados bancários) direto da sua conta digital
        {{ partnerName }}.
      </v-list-tile-sub-title>
    </v-list-tile-content>

    <v-list-tile-action>
      <v-btn outline color="indigo" @click="newPixPaymentForm">&nbsp;Realizar Pagamento&nbsp;</v-btn>
    </v-list-tile-action>
    <new-pix-payment-form />
  </v-list-tile>
</template>
<script>
import { EventBus } from "@/services/event-bus";
import { mapGetters } from 'vuex';
import PaymentIcon from '@/components/PaymentIcon.vue';

export default {
  name: "NewPixPayment",
  created() {
    this.$store.dispatch('account/getAccount');
  },
   computed: {
    ...mapGetters({
      account: 'account/account',
      partner: 'account/partner',
      partnerName: 'account/partnerName',
      pixErrors: "bills/pixPaymentError"
    }),
    paymentProvider() {
      return (this.account && this.account.bill_source) || 'banco_inter';
    }
  },
  components: {
    PaymentIcon,
    newPixPaymentForm: () =>
      import(
        "@/components/desktop/bills/actions/NewPixPaymentForm.vue"
      )
  },
  methods: {
    newPixPaymentForm() {
      EventBus.$emit("show-new-pix-payment-form");
    }
  }
};
</script>